module.exports = __webpack_public_path__ + "static/media/cleaning.f3d1b290.jpg";